// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3Dbt8","inputWrap":"styles_inputWrap__ZDhax","input":"styles_input__1B-1n"};